import { render, staticRenderFns } from "./SupportOpened.vue?vue&type=template&id=106218d8&scoped=true&"
import script from "./SupportOpened.vue?vue&type=script&lang=ts&"
export * from "./SupportOpened.vue?vue&type=script&lang=ts&"
import style0 from "./SupportOpened.vue?vue&type=style&index=0&id=106218d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106218d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
